import { render, staticRenderFns } from "./PassportArchiveReportView.vue?vue&type=template&id=765a450c&scoped=true&"
import script from "./PassportArchiveReportView.vue?vue&type=script&lang=ts&"
export * from "./PassportArchiveReportView.vue?vue&type=script&lang=ts&"
import style0 from "./PassportArchiveReportView.vue?vue&type=style&index=0&id=765a450c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765a450c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
